// extracted by mini-css-extract-plugin
export var container = "Layout-module--container--f70fd";
export var main = "Layout-module--main--8841c";